// Utility per Quill
// Considera false anche se stringa vuota, solo spazi, solo <p><br></p> o altri char invisibili
export function isQuillEmpty(str) {
  if (!str || typeof str !== 'string') return true;
  const cleaned = str
    .replace(/<p><br\/?><\/p>/gi, '') // rimuove <p><br></p>
    .replace(/<[^>]+>/g, '') // rimuove tutti i tag html
    .replace(/&nbsp;/g, '') // rimuove spazi non-break
    .replace(/\s+/g, ''); // rimuove tutti gli spazi
  return cleaned.length === 0;
}
